import { Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Loading from "../../../components/Loading";
import BookingRequestedModal from "./BookingRequestedModal";
import VoidPassengerModal from "../../../components/Modals/VoidPassengerModal";
import Header from "./Header";
import BookingBody from "./BookingBody";
import { useSearchParams } from "react-router-dom";

const BookingList = ({
  bookings,
  user,
  currentPage,
  setCurrentPage,
  totalPage,
  bookingPerPage,
  setBookingPerPage,
  corporate,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [bookingRequestModal, setBookingRequestModal] = useState(false);
  const [bookingId, setBookingId] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const [show, setShow] = useState(false);
  const [voidType, setVoidType] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();

  // const bookingPerPage = 5;

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
      setError(null);
    }
  }, [error]);

  // async function getTicket(booking) {
  //   setShow(true);
  //   // if (!booking?.flight?.retrievalPnr) return;

  //   // setLoading(true);
  //   // const res = await axios.post(API_URL + "flight/ticket", {
  //   //   PNR: booking?.flight?.PNR,
  //   // });

  //   // if (res.data?.AirTicketingRsp?.TicketFailureInfo) {
  //   //   setError(
  //   //     res?.data?.AirTicketingRsp?.TicketFailureInfo?._attributes?.Message
  //   //   );
  //   //   const data = {
  //   //     id: booking?._id,
  //   //     payment: "none",
  //   //     ticketNumber: "N/A",
  //   //     paymentStatus: "pending",
  //   //     status: "cancelled",
  //   //   };
  //   //   setLoading(false);
  //   //   dispatch(updateBooking(data));
  //   //   setTimeout(() => {
  //   //     navigate(0);
  //   //   }, 1000);
  //   // } else {
  //   //   const data = {
  //   //     id: booking?._id,
  //   //     payment: "wallet",
  //   //     serviceCharge: booking?.serviceCharge,
  //   //     systemFee: booking?.systemFee,
  //   //     ticketNumber:
  //   //       res.data?.AirTicketingRsp?.ETR?.Ticket?._attributes?.TicketNumber,
  //   //   };
  //   //   setLoading(false);
  //   //   dispatch(updateWallet(data));
  //   //   retrievePnr(booking?.flight);
  //   // }
  // }

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setBookingPerPage(newLimit);
    searchParams.set("limit", newLimit);
    setSearchParams(searchParams);
  };

  const rateDifference = Math.max(
    (corporate?.galileoRate / corporate?.bankRate).toFixed(3),
    1
  );

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="my-4 table-responsive">
      <div id="example2_wrapper" className="dataTables_wrapper no-footer">
        <table
          id="exampl2"
          className="table mb-4 card-table default-table display dataTablesCard dataTable no-footer"
        >
          <thead>
            <Header />
          </thead>
          <tbody>
            <BookingBody
              bookings={bookings}
              currentPage={currentPage}
              bookingPerPage={bookingPerPage}
              user={user}
              setBookingId={setBookingId}
              setLoading={setLoading}
              setError={setError}
              setShow={setShow}
              setVoidType={setVoidType}
              setBookingRequestModal={setBookingRequestModal}
              bookingRequestModal={bookingRequestModal}
              setSelectedBooking={setSelectedBooking}
              rateDifference={rateDifference}
            />
          </tbody>
        </table>
        <div className="flex justify-between items-center my-5">
          <div className="flex flex-1 justify-center">
            <Pagination
              count={totalPage}
              page={currentPage}
              onChange={handlePageChange}
              siblingCount={4}
            />
          </div>
          <div className="flex gap-3 items-center mr-3 text-black">
            <p lassName="mx-4">Limit</p>
            <select
              id="limit"
              className="w-20 form-select"
              value={bookingPerPage}
              onChange={handleLimitChange}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
            </select>
          </div>
        </div>
      </div>

      {bookingRequestModal && (
        <BookingRequestedModal
          bookingRequestModal={bookingRequestModal}
          setBookingRequestModal={setBookingRequestModal}
          bookingId={bookingId}
        />
      )}
      {show && (
        <VoidPassengerModal
          show={show}
          onHide={() => setShow(false)}
          booking={selectedBooking}
          setLoading={setLoading}
          setError={setError}
          voidType={voidType}
        />
      )}
    </div>
  );
};

export default BookingList;
